import PropTypes from 'prop-types';
import React from 'react';

import 'commons-forms/components/InputColorRadio/InputColorRadio.scss';

const InputColorRadio = ({ id, onChange, name, value, isSelected, disabled }) => {
    return (
        <div className="color-radio-wrapper">
            <input
                type="radio"
                name="color"
                id={id}
                checked={isSelected}
                onChange={() => onChange(name, value)}
                disabled={disabled}
            />
            <label className="color-radio-label" style={{ background: value }} htmlFor={id}>
                <span className="color-radio-box colorBox" />
            </label>
            <br />
            <font className="color-radio-wrapper--title">{name}</font>
        </div>
    );
};

InputColorRadio.defaultProps = {
    isRequired: false,
    isSelected: false,
    disabled: false,
};

InputColorRadio.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

InputColorRadio.displayName = 'InputColorRadio';

export default InputColorRadio;
